import { useQuery } from "@tanstack/react-query";
import { getServices } from "../services";

export function useServices() {
  return useQuery({
    queryKey: ["services"],
    queryFn: getServices,
  });
}
